var ParticleCollection = /** @class */ (function () {
    function ParticleCollection() {
    }
    return ParticleCollection;
}());
export { ParticleCollection };
